import { Link } from 'react-router-dom';
import { EmptyState } from '../components/EmptyState';

export function NotFoundPage() {
  return (
    <main className="mx-auto max-w-xl px-4 py-16">
      <EmptyState title="Esta página no existe" description="Revisa la dirección o vuelve a la consola." />
      <p className="mt-6 text-center">
        <Link to="/consola" className="font-semibold text-ink underline underline-offset-4">
          Ir a la consola
        </Link>
      </p>
    </main>
  );
}
